// extracted by mini-css-extract-plugin
module.exports = {"MobileLogo":"MobileLogo_MobileLogo__sS-TI"};